import { render, staticRenderFns } from "./Step4Capital.vue?vue&type=template&id=50db214e"
import script from "./Step4Capital.vue?vue&type=script&lang=js"
export * from "./Step4Capital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports